// Imports
// ------
import React from 'react';
import styled, { css } from 'styled-components';
import { Div, H2, P } from '@reuse';
import { breakup } from '@break';
import { Row, Column } from 'react-foundation';

// Styles
// ------
const Jacket = styled(Div)`
    position: relative;

    ${breakup.large`
        width: 100%;
        min-height: 100vh;
    `}
`;

const ImageJacket = styled(Div)`
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 1;
    overflow: hidden;

    ${props => props.bg === "DarkPurple" ? css`
        background-color: ${props => props.theme.bc1};
    ` : null }

    ${props => props.bg === "LightPurple" ? css`
        background-color: ${props => props.theme.bc2};
    ` : null }

    ${props => props.bg === "DarkBlue" ? css`
        background-color: ${props => props.theme.bc3};
    ` : null }

    ${props => props.bg === "LightBlue" ? css`
        background-color: ${props => props.theme.bc4};
    ` : null }

    ${props => props.bg === "Pink" ? css`
        background-color: ${props => props.theme.bc5};
    ` : null }

    &:after {
        content: '';
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        z-index: 3;
        background-color: rgba(000,000,000,0.4);
    }
`;

const Image = styled.img`
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    mix-blend-mode: luminosity;
`;

const ContentJacket = styled(Div)`
    position: relative;
    z-index: 4;
`;

// Component
// ------
const MortgageContent = ({ content }) => (
    <Jacket id={content.title.replace(/\s/g, "")} name={content.title.replace(/\s/g, "")}>
        {/* Image */}
        <ImageJacket bg={content.colour}>
            <Image src={content.image.url} alt={content.title} />
        </ImageJacket>

        {/* Content */}
        <ContentJacket valignLarge>
            <Row isExpanded>
                <Column small={12} medium={8} pushOnMedium={2} large={6} pushOnLarge={5}>
                    <Div pad>
                        <H2 smallSpace>{content.title}</H2>
                        <P>{content.excerpt}</P>
                    </Div>
                </Column>
            </Row>
        </ContentJacket>
    </Jacket>
);

export default MortgageContent;